module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAA9ElEQVQokXXSPUoDURQF4C+TwbgAOxtbwcaAWiQb8Ae7CKazSbRQhICdSzBopWMtBvvYWomKglXA1iZr0BiDFl5hQHPgwn3n3J93Hq+QZZnABLaxibngeujgDB+QhjCNLt5xjKfgF7CPLayhn8TkLu5QxRWm8BZ5Ffe4RilBM9btYRSTD7Ee+Qi7GKCRoI6jXDEUkOTOI7RRT1HGo78oo4bPuPID5tN/CuEGy2hgGP6+MEzxjEW85hraEXlsoJfgEi0Ux2wTWgudBOco4WRMUzG0SWSJn+daRQW3YXQmohZcBSsY/JruYwk7OMBs8C+4wKn4Gt9gWzgK1geKugAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/time.png
// module id = xxCs
// module chunks = 10